<template>
  <div class="track-wrap">
    <div class="track-content">
      <div class="page-header">追踪管理</div>
      <div class="header-filter">
        <el-select
          class="select-item"
          v-model="filterTable.platType"
          placeholder="请选择媒体渠道"
          @change="changePlatType"
        >
          <el-option label="全部渠道" :value="-1"> </el-option>
          <el-option label="今日头条" :value="1"> </el-option>
          <el-option label="广点通" :value="2"> </el-option>
          <el-option label="快手" :value="3"> </el-option>
          <el-option label="OPPO" :value="20"> </el-option>
        </el-select>
        <el-select class="select-item" v-model="filterTable.pkg" filterable @change="changeFilter">
          <el-option label="全部应用" :value="-1"> </el-option>
          <el-option
            v-for="item of appList"
            :key="item.id"
            :label="item.appName + '（' + item.pkg + '）'"
            :value="item.pkg"
          >
          </el-option>
        </el-select>
        <!-- <el-button class="add-btn" icon="el-icon-plus" plain @click="addConf">新增配置</el-button> -->
      </div>
      <div class="table-wrap">
        <el-table :data="tableData">
          <el-table-column prop="appName" label="应用"> </el-table-column>
          <el-table-column prop="pkg" label="包名"> </el-table-column>
          <el-table-column prop="platform" label="媒体"> </el-table-column>
          <el-table-column prop="dataTrackUrl" label="点击监测链接" width="300px">
            <template slot-scope="scope">
              <div class="link-wrap" :title="scope.row.dataTrackUrl">
                <span class="link">{{ scope.row.dataTrackUrl }}</span>
                <el-button type="text" @click="copyLink(scope.row.dataTrackUrl)">复制</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="expires" label="归因窗口">
            <template slot-scope="scope"> {{ scope.row.expires }}天 </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-switch
                class="switch-wrap"
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                :width="28"
                @change="changeStatus(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="creator" label="创建人"> </el-table-column>
          <el-table-column prop="createDateStr" label="创建时间"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="editData(scope.row)">编辑</el-button>
              <el-button type="text" @click="deleteData(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <self-pagination
          class="table-pagination"
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changePageSize"
        ></self-pagination>
      </div>
    </div>

    <!-- 新增配置弹框 -->
    <el-dialog
      :title="editId ? '编辑配置' : '新增配置'"
      :visible.sync="dialogVisible"
      width="448px"
      @closed="modalClosed"
      :close-on-click-modal="false"
    >
      <div class="form-wrap">
        <el-form :model="modalConf" :rules="rules" ref="tableRef">
          <el-form-item label="渠道：" prop="platType">
            <el-select
              class="form-item"
              @change="changeEditPlatType"
              v-model="modalConf.platType"
              placeholder="请选择媒体渠道"
            >
              <el-option label="今日头条" :value="1"> </el-option>
              <el-option label="广点通" :value="2"> </el-option>
              <el-option label="快手" :value="3"> </el-option>
              <el-option label="OPPO" :value="20"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="应用：" prop="app">
            <el-select class="form-item" v-model="modalConf.app" filterable @change="selectApp">
              <el-option
                v-for="item of productList"
                :key="item.id"
                :label="item.appName + '（' + item.pkg + '）'"
                :value="item.pkg"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="包名：">
            <el-input
              class="form-item"
              v-model="modalConf.pkg"
              placeholder="请选择应用"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveTable" :loading="isSaving">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getConvertProductList } from "@/api/api.js";
import {
  queryDataTrackPara,
  addDataTrackPara,
  modifyDataTrackPara,
  deleteDataTrackPara,
} from "@/api/tools.js";
import { copyText } from "@/utils/tool.js";
export default {
  name: "TrackManage",
  data() {
    return {
      filterTable: {
        pkg: -1,
        platType: -1,
      },
      modalConf: {
        app: null,
        pkg: "",
        platType: null,
      },
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      tableData: [],
      dialogVisible: false,
      editId: null,
      appList: [],
      productList: [],
      formData: {
        callBackName: null,
      },
      rules: {
        app: [
          {
            required: true,
            message: "请选择应用",
            trigger: ["blur"],
          },
        ],
        platType: [
          {
            required: true,
            message: "请选择渠道",
            trigger: ["blur"],
          },
        ],
      },
      isSaving: false,
    };
  },
  mounted() {
    this.ininSelect();
    this.selectTable();
  },
  methods: {
    ininSelect() {
      //产品
      getConvertProductList({
        platType: this.filterTable.platType == -1 ? null : this.filterTable.platType,
      }).then((res) => {
        if (res.code === "0000") {
          this.appList = res.data;
        }
      });
    },
    selectTable() {
      let parmas = {
        page: this.pageData.page,
        size: this.pageData.size,
      };
      this.filterTable.pkg === -1 ? "" : (parmas.pkg = this.filterTable.pkg);
      this.filterTable.platType === -1 ? "" : (parmas.platType = this.filterTable.platType);
      queryDataTrackPara(parmas).then((res) => {
        if (res.code === "0000") {
          this.tableData = res.dataTrackParas;
          this.pageData.total = res.totalCount;
        }
      });
    },
    addConf() {
      this.editId = null;
      this.modalConf.app = null;
      this.modalConf.pkg = "";
      this.modalConf.platType = null;
      this.dialogVisible = true;
    },
    saveTable() {
      this.$refs.tableRef.validate((valid) => {
        if (valid) {
          let parmas = {
            platType: this.modalConf.platType,
            pkg: this.modalConf.pkg,
          };
          this.isSaving = true;
          if (this.editId) {
            //编辑
            parmas.id = this.editId;
            modifyDataTrackPara({
              data: JSON.stringify(parmas),
            }).then((res) => {
              this.isSaving = false;
              if (res.code === "0000") {
                this.$message({
                  message: "配置修改成功",
                  type: "success",
                });
                this.dialogVisible = false;
                this.selectTable();
              }
            });
          } else {
            addDataTrackPara({
              data: JSON.stringify(parmas),
            }).then((res) => {
              this.isSaving = false;
              if (res.code === "0000") {
                this.$message({
                  message: "新增配置成功",
                  type: "success",
                });
                this.dialogVisible = false;
                this.selectTable();
              }
            });
          }
        }
      });
    },
    modalClosed() {
      this.$refs.tableRef.resetFields();
    },
    selectApp(data) {
      this.modalConf.pkg = data;
    },
    editData(data) {
      this.editId = data.id;
      this.modalConf.app = data.pkg;
      this.modalConf.pkg = data.pkg;
      this.modalConf.platType = data.platType;
      this.dialogVisible = true;
      this.getProductList();
    },
    changeEditPlatType() {
      this.modalConf.app = null;
      this.modalConf.pkg = "";
      this.getProductList();
    },
    getProductList() {
      getConvertProductList({
        platType: this.modalConf.platType == -1 ? null : this.modalConf.platType,
      }).then((res) => {
        if (res.code === "0000") {
          this.productList = res.data;
        }
      });
    },
    deleteData(data) {
      this.$confirm("确定删除“" + data.appName + "”的配置?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteDataTrackPara({
            id: data.id,
          }).then((res) => {
            if (res.code === "0000") {
              this.$message({
                message: "配置删除成功",
                type: "success",
              });
              if (this.tableData.length === 1 && this.pageData.page > 1) {
                this.pageData.page--;
              }
              this.selectTable();
            }
          });
        })
        .catch(() => {});
    },
    copyLink(str) {
      if (copyText(str)) {
        this.$message({
          message: "复制成功",
          type: "success",
        });
      }
    },
    changePage(page) {
      this.pageData.page = page;
      this.selectTable();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.selectTable();
    },
    async changePlatType() {
      await this.ininSelect();
      this.changeFilter();
    },
    changeFilter() {
      this.pageData.page = 1;
      this.selectTable();
    },
    changeStatus(data) {
      modifyDataTrackPara({
        data: JSON.stringify({
          id: data.id,
          status: data.status,
          platType: data.platType,
        }),
      }).then((res) => {
        if (res.code === "0000") {
          this.$message({
            message: "状态修改成功",
            type: "success",
          });
        } else {
          this.selectTable();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.track-wrap {
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  .track-content {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    height: 100%;
    padding: 16px 24px;
    box-sizing: border-box;
    overflow: auto;
    .page-header {
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
      font-size: 15px;
    }
    .header-filter {
      display: flex;
      align-items: center;
      margin-top: 16px;
      .select-item {
        width: 200px;
        margin-right: 24px;
      }
      .add-btn {
        color: rgba(24, 144, 255, 1);
        border-color: rgba(24, 144, 255, 1);
        margin-left: auto;
      }
    }
    .table-wrap {
      margin-top: 16px;
      .link-wrap {
        display: flex;
        align-items: center;
        .link {
          display: inline-block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .table-pagination {
        padding-right: 0px;
        /deep/.el-pagination {
          padding-right: 0px;
        }
      }
      .switch-wrap {
        /deep/ .el-switch__core:after {
          width: 11px;
          height: 11px;
          top: 1px;
        }
        /deep/.el-switch__core {
          height: 14px;
        }
      }
      /deep/ .el-switch.is-checked .el-switch__core::after {
        margin-left: -13px;
      }
    }
  }
  .form-wrap {
    .form-item {
      width: 340px;
    }
    /deep/ .el-form-item__label {
      padding-right: 0px;
    }
  }
}
</style>
